var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "section",
        { staticClass: "l-header header-page", attrs: { id: "header" } },
        [
          _c(
            "a",
            {
              staticClass:
                "col-xs-12 col-md-4 col-lg-3 col-xl-2 l-header--logo",
              attrs: { href: "/", title: "Control Panel" }
            },
            [_c("img", { attrs: { src: _vm.whitelabel.LOGO } })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "l-container l-container--full l-header--nav" },
            [
              _c("nav", { staticClass: "c-menu" }, [
                _c("ul", { staticClass: "c-menu__list" }, [
                  _c(
                    "li",
                    { staticClass: "c-menu__item" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "c-menu__link",
                          attrs: {
                            to: { name: "domains.index" },
                            title: "Domains"
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "icon-ccs icon-domains-ccs"
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "c-menu__entry" }, [
                            _vm._v("Domains")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$store.getters["user/isAccountOwner"]
                    ? _c("li", { staticClass: "c-menu__item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "c-menu__link",
                            attrs: {
                              href: _vm.$laroute.route("entities_index"),
                              title: "Servers"
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "icon-ccs icon-servers-ccs"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "c-menu__entry" }, [
                              _vm._v("Servers")
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.getters["user/isAccountOwner"]
                    ? _c("li", { staticClass: "c-menu__item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "c-menu__link",
                            attrs: {
                              href: _vm.$laroute.route("reports"),
                              title: "Reports"
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "icon-ccs icon-reports-ccs"
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "c-menu__entry" }, [
                              _vm._v("Reports")
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.getters["user/isReseller"]
                    ? _c(
                        "li",
                        { staticClass: "c-menu__item" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "c-menu__link",
                              attrs: {
                                to: { name: "reseller.info_page" },
                                title: "Account"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "icon-ccs icon-users-light-ccs"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "c-menu__entry" }, [
                                _vm._v("Reseller")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "l-header--account" }, [
            _c("ul", { staticClass: "logged-bar" }, [
              _c(
                "li",
                { staticClass: "logged-bar__item" },
                [
                  _vm.$store.state.user.account_data.logged_in_as === 1
                    ? [
                        _vm._v("\n                        Logged in as "),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$store.state.user.user_data.email))
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "warning", size: "sm" },
                            on: { click: _vm.$root.$children[0].logoutAsUser }
                          },
                          [
                            _vm._v(
                              "\n                            Logout as user\n                        "
                            )
                          ]
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass:
                    "logged-bar__item logged-bar__dropdown-parent logged-bar__item--account-details"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "logged-bar__dropdown" }, [
                    _c("ul", { staticClass: "logged-bar__dropdown--item" }, [
                      _c("li", [
                        _c("ul", [
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "account.information" },
                                    title: "Account"
                                  }
                                },
                                [
                                  _c("span", { staticClass: "client-name" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$store.state.user.user_data.email
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("li", { staticClass: "client-name--wrapper" }, [
                            _c("span", { staticClass: "client-email" }, [
                              _vm._v(
                                "\n                                            Portal Id: " +
                                  _vm._s(
                                    _vm.$store.state.user.user_data.company_id
                                  ) +
                                  "\n                                        "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "account.information" },
                                    title: "Account"
                                  }
                                },
                                [
                                  _c("span", { staticClass: "c-menu__entry" }, [
                                    _vm._v("Account")
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "account.change_password" },
                                    title: "Account"
                                  }
                                },
                                [
                                  _c("span", { staticClass: "c-menu__entry" }, [
                                    _vm._v("Change Password")
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "li",
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "account.2fa" },
                                    title: "Account"
                                  }
                                },
                                [
                                  _c("span", { staticClass: "c-menu__entry" }, [
                                    _vm._v("2FA Authentication")
                                  ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.can_have_sub_accounts
                            ? _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { name: "account.sub_accounts" },
                                        title: "Account"
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "c-menu__entry" },
                                        [_vm._v("Sub-accounts")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.$store.getters["user/isAccountOwner"]
                        ? _c("li", [
                            _c("ul", [
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.whitelabel.BILLING_URL,
                                      title: "Billing Area"
                                    }
                                  },
                                  [_vm._v("Billing Area")]
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.whitelabel.SUPPORT_URL,
                                      title: "Tickets & Support"
                                    }
                                  },
                                  [_vm._v("Tickets & Support")]
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("li", { staticClass: "logged-bar__item" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#", title: "Logout" },
                            on: { click: _vm.$root.$children[0].logout }
                          },
                          [_vm._v("Logout")]
                        )
                      ])
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mobile-menu--toggle" }, [
            _c("label", { attrs: { for: "mobileTrigger" } }, [
              _c("span", { staticClass: "wl-menu" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 448 512"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "account-details" }, [
      _c("span", { staticClass: "icon-profile-ccs" }),
      _vm._v(" "),
      _c("span", { staticClass: "icon-maximize-ccs" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }